<template>
  <div
    ref="buttonDropDown"
    class="drop-down-button flex-center"
    :class="[
      hasBorderParent ? 'border-drop-down-btn' : '',
      disabled ? 'disabled-btn' : '',
      isBtnFooterHelpFul ? 'btn-footer-helpful' : '',
    ]"
  >
    <menu-wrapper
      class="widget-more-container widget-btn"
      :class="[type]"
      :disabled="disabled"
      :max-height="maxHeight"
      :min-width="minWidth"
      :position="position"
    >
      <template #menu-button="{toggleMenu}">
        <button
          class="btn flex-row primary-button"
          :class="[type, classCustom, hasBorder ? '' : 'btn-border-none']"
          :disabled="disabled"
          @click.prevent="e => toggleMainMenu(e, toggleMenu)"
        >
          <div v-if="leftIcon" :class="['icon24 icon left', leftIcon]">&nbsp;</div>
          <div v-if="text" class="text" :class="[{'pl-0': leftIcon}]">
            {{ text }}
          </div>
        </button>
        <div v-if="hasButtonLine" class="button-line" />

        <button
          class="widget-more"
          :class="[type, classCustom, hasBorder ? '' : 'btn-border-none', isBtnFooterHelpFul ? 'footer' : '']"
          :disabled="disabled"
          @click.prevent="e => toggleMainMenu(e, toggleMenu)"
        />
      </template>
      <template #menu-content>
        <menu-item
          v-for="(item, index) in menuItems"
          :key="index"
          :seperator-bottom="item.seperatorBottom"
          :disabled-item="item.disabledItem"
          :class="[item.class, item.IsSubMenu && 'menu-group-item', item.IsSubMenu && 'menu-sub-group' + index]"
          @menu-item-click="clickItem(item)"
          @mouseenter="
            e => {
              item.IsSubMenu && toogleMenu(e, index, item);
            }
          "
          @mouseleave="
            e => {
              item.IsSubMenu && toogleMenu(e, index, item);
            }
          "
        >
          <div v-if="item.IsSubMenu">
            <div class="flex-between flex1">
              <div class="content">
                {{ item.text }}
              </div>
              <div :ref="'buttonContainerSub' + index" :class="['icon24 icon right-arrow-black', item.icon]" />
            </div>
            <teleport to="body">
              <ul
                v-if="item.isShow"
                :ref="'listSub' + index"
                class="menu-wrapper-menu"
                :class="[classRoot, 'menu-sub-group' + index]"
                :name="''"
                :style="{
                  left: left,
                  right: right,
                  top: top,
                  bottom: bottom,
                  maxHeight: maxHeight + 'px',
                  overflow: 'auto',
                  minWidth: minWidth + 'px',
                }"
                @mouseover="e => toogleMenu(e, index, item)"
                @mouseleave="e => toogleMenu(e, index, item)"
              >
                <menu-item v-for="(itemSub, index) in item.subItem" :key="index" @menu-item-click="clickItem(itemSub)">
                  {{ itemSub.text }}
                </menu-item>
              </ul>
            </teleport>
          </div>
          <div v-else>
            {{ item.text }}
          </div>
        </menu-item>
      </template>
    </menu-wrapper>
  </div>
</template>
<script>
import {defineComponent, ref, getCurrentInstance, nextTick, reactive, onMounted, onBeforeUnmount} from 'vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import componentUtil from '@/commons/componentUtil';

export default defineComponent({
  name: 'MsDropDownButton',
  components: {
    MenuWrapper,
    MenuItem,
  },
  props: {
    // Text hiển thị
    text: {
      defualt: null,
      type: String,
    },
    hasButtonLine: {
      default: true,
      type: Boolean,
    },
    // Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    // Icon phải
    rightIcon: {
      default: 'chevron-down-white',
      type: String,
    },
    // Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
    type: {
      default: 'primary',
      type: String,
    },
    /**
     * Trạng thái button disabled
     */
    disabled: {
      default: false,
      type: Boolean,
    },
    // chiều cao tối đa cho menu để hiển thị scroll nếu menu quá dài
    maxHeight: {
      default: null,
      type: [Number, String],
    },
    minWidth: {
      default: null,
      type: [Number, String],
    },
    /**
     * Danh sách các item của context menu
     */
    menuItems: {
      type: Array,
      default: new Array(),
    },
    /**
     * ĐVThi 18/02/2020
     * muốn đặt thêm stype cho lớp mục đích có cách để trên form tìm được đến control
     */
    classCustom: {
      default: '',
      type: String,
    },
    /**
     * NNLAM 26/02/2020
     * có cho phép tự custom vị trí dropdown menu hay không
     */
    customPositionMenu: {
      type: Boolean,
      default: false,
    },
    /**
     * NNLAM 26/02/2020
     * Set lại chiều dài menu dropdown
     */
    customWidth: {
      type: Number,
      default: 0,
    },
    /**
     * NNLAM 26/02/2020
     * khoảng cách của button so với lề trên/dưới
     */
    heightOffset: {
      type: Number,
      default: 5, // 25
    },
    /**
     * NNLAM 26/02/2021
     * khoảng cách của button so với lề trái/phải
     */
    widthOffset: {
      type: Number,
      default: 25,
    },
    /**
     * NNLAM 26/02/2021
     * Có show menu khi click vào icon right của button không, mặc định có
     */
    hasShowMenu: {
      type: Boolean,
      default: true,
    },
    /**
     * NNLAM 26/02/2021
     * Có tooltip cho btt không
     */
    tooltipText: {
      type: [String, Object],
      default: null,
    },
    // border hiển thị cho các button con
    hasBorder: {
      default: false,
      type: Boolean,
    },
    // border bên ngoài 2 button con
    hasBorderParent: {
      default: false,
      type: Boolean,
    },
    // button tiện ích footer có hover màu xanh nước biển
    isBtnFooterHelpFul: {
      default: false,
      type: Boolean,
    },
    /**
     * Thêm class root để style menu-wrapper
     * tbngoc 19.07.2022
     */
    classRoot: {
      default: '',
      type: String,
    },
    position: {
      default: null,
      type: Object,
    },
    /**
     * Phím tắt để mở dropdown (ví dụ: 'ctrl+i', 'ctrl+u')
     * Chỉ dropdown có prop này mới được trigger bởi phím tắt tương ứng
     */
    shortcutKey: {
      default: null,
      type: String,
    },
  },
  setup(props, {emit}) {
    // Các thuộc tính cho subMenu
    const top = ref(0);
    const left = ref('unset');
    const right = ref('unset');
    const bottom = ref('unset');
    const position = reactive({
      at: 'right+15 top+20',
      my: 'left bottom',
    });
    const {proxy} = getCurrentInstance();
    const buttonDropDown = ref(null);

    const clickItem = item => {
      emit('menuClick', item);
    };

    // const toggleMenu = ref(false);
    // end -----------------------------------------------------------------------
    /**
     * Set sự kiện cho menu được hiển thị
     * tbngoc 01.08.2022
     */
    function setPosition(parent, group, posi) {
      top.value = '0px';
      left.value = '0px';

      nextTick(() => {
        const positions = componentUtil.getPosition(parent, group, posi);

        top.value = positions.top + 'px';
        left.value = positions.left + 'px';
      });
    }
    /**
     * Sự kiện toggle menu tại item trong dropdown button
     * tbngoc 01.08.2022
     */
    function toogleMenu(e, index, item) {
      e.stopPropagation();
      //Bổ sung timeout do 2 component cha con ko sát nháu => di chuột ra ngoài 1 khoảng
      setTimeout(() => {
        if (!proxy.disabled) {
          let ele = e.toElement;
          ele = ele || (e.type == 'mouseenter' ? e.originalTarget : e.relatedTarget);
          const group = ele.closest('.menu-sub-group' + index);
          if (group) {
            item.isShow = true;
            nextTick(() => {
              setPosition(
                proxy.$refs['buttonContainerSub' + index][0],
                proxy.$refs['listSub' + index][0],
                item.position || position,
              );
            });
          } else {
            item.isShow = false;
          }
        }
      }, 100);
    }

    function toggleMainMenu(event, toggleMenu) {
      if (toggleMenu && typeof toggleMenu === 'function') {
        toggleMenu(event);
      }
      if (props.menuItems && Array.isArray(props.menuItems)) {
        props.menuItems.forEach(item => (item.isShow = false));
      }
    }

    /**
     * Xử lý phím tắt để mở dropdown
     */
    function handleKeyDown(event) {
      // Nếu không có shortcutKey được định nghĩa, không xử lý
      if (!props.shortcutKey) {
        return;
      }

      // Parse shortcutKey (ví dụ: 'ctrl+i' thành {ctrl: true, key: 'i'})
      const parts = props.shortcutKey.toLowerCase().split('+');
      const modifiers = parts.slice(0, -1);
      const key = parts[parts.length - 1];

      // Kiểm tra phím chính
      if (event.key.toLowerCase() !== key) {
        return;
      }

      // Kiểm tra các modifier keys
      let matches = true;
      
      // Ctrl (hoặc Cmd trên Mac)
      if (modifiers.includes('ctrl')) {
        if (!event.ctrlKey && !event.metaKey) {
          matches = false;
        }
      } else {
        // Nếu không yêu cầu Ctrl, không được nhấn Ctrl (trừ khi có Meta cho Mac)
        if (event.ctrlKey && !event.metaKey) {
          matches = false;
        }
      }

      // Alt
      // if (modifiers.includes('alt')) {
      //   if (!event.altKey) {
      //     matches = false;
      //   }
      // } else if (event.altKey) {
      //   matches = false;
      // }

      // // Shift
      // if (modifiers.includes('shift')) {
      //   if (!event.shiftKey) {
      //     matches = false;
      //   }
      // } else if (event.shiftKey) {
      //   matches = false;
      // }

      if (matches) {
        event.preventDefault();
        event.stopPropagation();
        
        // Chỉ mở dropdown nếu button không bị disabled
        if (!props.disabled && buttonDropDown.value) {
          // Tìm button widget-more trong component
          const button = buttonDropDown.value.querySelector('.widget-more');
          if (button) {
            // Sử dụng setTimeout để đảm bảo event không bị conflict với documentClick listener
            setTimeout(() => {
              button.click();
            }, 0);
          }
        }
      }
    }

    /**
     * Đăng ký event listener khi component được mount
     */
    onMounted(() => {
      // Sử dụng capture phase để xử lý event trước các listener khác
      document.addEventListener('keydown', handleKeyDown, true);
    });

    /**
     * Hủy đăng ký event listener khi component bị unmount
     */
    onBeforeUnmount(() => {
      document.removeEventListener('keydown', handleKeyDown, true);
    });

    return {
      clickItem,
      top,
      left,
      right,
      bottom,
      toogleMenu,
      toggleMainMenu,
      buttonDropDown,
    };
  },
});
</script>

<style scoped lang="scss">
@import '@/assets/scss/components/MsButton.scss';

:deep(.btn) {
  min-width: 60px;
}

.drop-down-icon {
  width: 36px;
  height: 24px;
  margin: 0 !important;
  .icon {
    margin: 0;
    cursor: pointer;
  }
}

:deep(.menu-button-container) {
  display: flex;
  align-items: center;
}
:deep(.flex) {
  display: flex;
}
:deep(.wrapper-utilities) {
  z-index: 1000 !important;
}
.context-item {
  height: 36px;
  padding: 2px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  .context-text {
    padding: 0 8px;
  }
  &:hover {
    cursor: pointer;
    background: $hover-and-active-bg-control;
    color: $primary;
  }
}
.context-icon {
  margin-right: 8px;
}
.color-red {
  color: #ff0000;
}
.button-line {
  display: inline-block;
  width: 1px;
  height: 16px;
  margin-left: 5px;
  background-color: #fff;
}
.drop-down-button {
  &.border-drop-down-btn {
    border: 1px solid #afafaf;
    border-radius: 3px;
  }
  button {
    &.primary-button {
      border-end-end-radius: unset;
      border-start-end-radius: unset;
    }
  }
}
</style>
